import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import moment from "moment";

import { GENDER_OPTIONS } from "./static";
import api from "../../config/api";
import CustomButton from "../../component/CustomButton/CustomButton";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import List from "./components/List";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import PageHead from "../../component/pageHead/PageHead";
import constants from "../../config/constants";
import { isNetworkRequestFailedError } from "../../config/helpers";
// import CustomList from "../../component/CustomList/CustomList";

class PersonalDetails extends Component {
  constructor() {
    super();
    this.state = {
      personalDetailsObj: {},
      gender: "",
      phone: "",
      confrirmPhone: "",
      email: "",
      confirmEmail: "",
      isLoading: false,
      stateOptions: null,
      editing: false,
    };
  }

  componentDidMount() {
    const { history, setHistory } = this.props;

    this.getAccountOfficerInfo();

    setHistory(history);
  }

  handleChange = (key, e) => {
    const payload = {
      [key]: e.target.value,
    };

    this.setState(payload);
  };

  getAccountOfficerInfo = async () => {
    const { user, accountOfficer } = this.props;

    try {
      if (accountOfficer) return;

      if (user.User.userType !== constants.MEMBER_CODE) {
        return;
      }

      this.setState({ isLoading: true });

      const response = await api.getAccountOfficer(
        { pin: user.User.rsaPin },
        user.token
      );

      this.props.setAccountOfficerInfo(response.data.result);
    } catch (e) {
      this.props.setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? this.getAccountOfficerInfo
          : null,
      });
    }

    this.setState({ isLoading: false });
  };

  startEditing = async () => {
    const { profile, token, User } = this.props.user;

    try {
      this.setState({ isLoading: true });

      let phone = profile.Phone;
      let email = profile.Email;

      if (User.userType === constants.EMPLOYER_CODE) {
        phone = User.mobileNumber;
        email = User.Email;
      }

      const payload = { countryCode: "NG" };

      const response = await api.fetchState(payload, token);

      this.setState({
        stateOptions: response.data.result,
        editing: true,
        gender: profile.Gender,
        phone,
        email,
        stateOfOrigin: profile.State_Of_Origin,
        residentialAddress1: profile.ResidentialAddress1,
        residentialAddress2: profile.ResidentialAddress2,
        officeStreetAddress1: profile.OfficeStreetAddress1,
        officeStreetAddress2: profile.OfficeStreetAddress2,
        confirmEmail: profile.Email,
        confirmPhone: profile.Phone,
      });
    } catch (e) {
      this.props.setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.startEditing : null,
      });
    }

    this.setState({ isLoading: false });
  };

  finishedEditing = async (shouldSave) => {
    const { user, setAlertMessage } = this.props;

    if (shouldSave) {
      this.setState({ isLoading: true });

      let pin = user.profile.pin;
      let isPhoneValidate = true;
      let isEmailValidate = true;

      if (user.User.userType === constants.EMPLOYER_CODE) {
        pin = user.User.employerCode;
      }
      try {
        if (this.state.phone !== this.state.confirmPhone) {
          isPhoneValidate = false;
          throw new Error("Phone Number must be same");
        } else if (
          this.state.email.toLowerCase() !==
          this.state.confirmEmail.toLowerCase()
        ) {
          isEmailValidate = false;
          throw new Error("Email Address must be same");
        }

        const payload = {
          updateDetail: {
            PIN: user.profile.pin,
            gender: this.state.gender,
            phone: this.state.phone,
            email: this.state.email,
            stateOfOrigin: this.state.stateOfOrigin,
            ResidentialAddress1: this.state.residentialAddress1,
            ResidentialAddress2: this.state.residentialAddress2,
            OfficeStreetAddress1: this.state.officeStreetAddress1,
            OfficeStreetAddress2: this.state.officeStreetAddress2,
            confirmEmail: this.state.email,
            confirmPhone: this.state.phone,
          },
        };

        const response = await api.custInformationUpdate(
          payload,
          user.token,
          pin
        );

        if (user.User.userType === constants.MEMBER_CODE) {
          const response2 = await api.fetchProfile({ pin }, user.token);
          user.profile = (response2.data && response2.data.result) || {};

          this.props.setUser({ ...user });
        }

        setAlertMessage({ type: "success", message: response.data.result });
      } catch (e) {
        setAlertMessage({
          type: "error",
          message: e.message,
          onTryAgain: isNetworkRequestFailedError(e)
            ? () => this.finishedEditing(shouldSave)
            : null,
        });
      }

      this.setState({ isLoading: false });

      if (!isPhoneValidate || !isEmailValidate) {
        this.setState({ editing: true });
      } else {
        this.setState({ editing: false });
      }
    } else {
      this.setState({ editing: false });
    }
  };

  renderButtons = () => {
    if (this.state.editing) {
      return (
        <Row className="justify-content-center mb-2">
          <Col md={3} sm={6}>
            <CustomButton
              onClick={this.finishedEditing.bind(this, false)}
              buttonClasses="btn-block"
              buttonText="Cancel"
            />
          </Col>
          <Col md={3} sm={6}>
            <CustomButton
              onClick={this.finishedEditing.bind(this, true)}
              buttonClasses="btn-block"
              buttonText="Save"
            />
          </Col>
        </Row>
      );
    } else {
      return (
        <Row className="justify-content-center mb-2">
          <Col md={3} sm={6}>
            <CustomButton
              onClick={this.startEditing}
              buttonClasses="btn-block"
              buttonText="Edit"
            />
          </Col>
        </Row>
      );
    }
  };

  renderAccountOfficer = () => {
    const { accountOfficer } = this.props;

    if (!accountOfficer) return;

    return (
      <>
        <PageHead title="ACCOUNT OFFICER" containerStyles={{ width: "100%" }} />
        <ul className="custom-list-container my-2">
          <List label="Agent Name" value={accountOfficer.Agent_Name} />
          <List label="Agent Phone" value={accountOfficer.Agent_Phone} />
          <List label="Agent Email" value={accountOfficer.Agent_Email} />
        </ul>
      </>
    );
  };

  render() {
    const { user } = this.props;
    const { editing, isLoading, stateOptions } = this.state;

    let firstName = user.profile.Firstname;
    let middleName = user.profile.Middlename;
    let surname = user.profile.Lastname;
    let email = user.profile.Email;
    let phone = user.profile.Phone;

    if (user.User.userType === constants.EMPLOYER_CODE) {
      firstName = user.User.firstName;
      middleName = user.User.middleName;
      surname = user.User.surname;
      email = user.User.Email;
      phone = user.User.mobileNumber;
    }

    if (editing) {
      email = this.state.email;
      phone = this.state.phone;
    }

    const gender = editing ? this.state.gender : user.profile.Gender;
    const stateOfOrigin = editing
      ? this.state.stateOfOrigin
      : user.profile.State_Of_Origin;

    const residentialAddress1 = editing
      ? this.state.residentialAddress1
      : user.profile.ResidentialAddress1;
    const residentialAddress2 = editing
      ? this.state.residentialAddress2
      : user.profile.ResidentialAddress2;
    const officeStreetAddress1 = editing
      ? this.state.officeStreetAddress1
      : user.profile.OfficeStreetAddress1;
    const officeStreetAddress2 = editing
      ? this.state.officeStreetAddress2
      : user.profile.OfficeStreetAddress2;
    return (
      <Container>
        <PageHead
          title="PERSONAL DETAILS"
          containerStyles={{ width: "100%" }}
        />
        <ul className="custom-list-container my-2">
          <List label="First Name" value={firstName} />
          <List label="Middle Name" value={middleName} />
          <List label="Last Name" value={surname} />
          <List
            editing={editing}
            onChange={this.handleChange.bind(this, "gender")}
            label="Gender"
            type="select"
            options={GENDER_OPTIONS}
            value={gender}
          />
          <List
            editing={editing}
            onChange={this.handleChange.bind(this, "residentialAddress1")}
            label="Residential Address 1"
            value={residentialAddress1}
          />
          <List
            editing={editing}
            onChange={this.handleChange.bind(this, "residentialAddress2")}
            label="Residential Address 2"
            value={residentialAddress2}
          />
          <List
            label="State of Origin"
            type="select"
            editing={editing}
            options={stateOptions}
            optionLabel="stateName"
            optionValue="stateCode"
            onChange={this.handleChange.bind(this, "stateOfOrigin")}
            value={stateOfOrigin}
          />
          <List
            label="State of Residence"
            value={user.profile.State_Of_residence}
          />
          <List
            editing={editing}
            onChange={this.handleChange.bind(this, "phone")}
            label="Phone"
            value={phone}
          />

          <div hidden={this.state.editing === false}>
            <List
              onChange={this.handleChange.bind(this, "confirmPhone")}
              editing={editing}
              label="Confirm Phone Number"
              value={this.state.confirmPhone}
            />
          </div>

          <List
            label="Date of Birth"
            value={moment(user.profile.DATE_OF_BIRTH).format("MMM D, YYYY")}
          />
          <List
            onChange={this.handleChange.bind(this, "email")}
            editing={editing}
            label="Email"
            value={email}
          />

          <div hidden={this.state.editing === false}>
            <List
              onChange={this.handleChange.bind(this, "confirmEmail")}
              editing={editing}
              label="Confirm Email Address"
              value={this.state.confirmEmail}
            />
          </div>

          <List label="Designation" value={user.profile.Designation} />
          <List label="Employer Name" value={user.profile.EMPLOYER_NAME} />
          <List label="Employer Code" value={user.profile.EmployerCode} />
          <List
            onChange={this.handleChange.bind(this, "officeStreetAddress1")}
            editing={editing}
            label="Office Address 1"
            value={officeStreetAddress1}
          />
          <List
            onChange={this.handleChange.bind(this, "officeStreetAddress2")}
            editing={editing}
            label="Office Address 2"
            value={officeStreetAddress2}
          />
          <List label="Office town" value={user.profile.OfficeTown} />
        </ul>
        {this.renderButtons()}
        {this.renderAccountOfficer()}
        {/* <CustomList data={personalDetailsObj} /> */}
        {isLoading && <CustomLoader />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  accountOfficer: state.auth.accountOfficer,
});

const mapDispatchToProps = {
  setUser: authAction.setUser,
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
  setAccountOfficerInfo: authAction.setAccountOfficerInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetails);
